import { Divider, Skeleton } from "@mui/material";
import MoneyFormatter from "../../../components/moneyFormatter";
import { useGetTransactionSummaryQuery } from "../../../services/PaymentToolApi";

const TableHeaderInfo = {
  padding: '1em',
  margin: '0 0 1px 0',
  borderRadius: '1em 1em 0 0',
  backgroundColor: 'white',
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'space-between'
}

function TransactionSummarySkeleton () {
  return(
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'flex-end', margin: '0.5em 0 0 0' }} >
      
    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }} >Rewards:</p>
      <Skeleton variant="text" width={40} height={22} />
    </div>

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Bonuses:</p>
      <Skeleton variant="text" width={40} height={22} />
    </div>

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Royalties:</p>
      <Skeleton variant="text" width={40} height={22} />
    </div>

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Adjustments:</p>
      <Skeleton variant="text" width={40} height={22} />
    </div>

    <Divider orientation="vertical" flexItem light='false' sx={{ margin: '0', borderRightWidth: 3, bgcolor: 'var(--orange)' }} />

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0 1em' }} >
      <p style={{ color: 'var(--orange)', fontWeight: '700', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >TOTAL:</p>
      <Skeleton variant="text" width={40} height={22} />
    </div>

  </div>
  )  
}

export default function TransactionSummary({selectedYear, selectedPeriod, userID}){
  const { data: transactionsSummary, isLoading: transactionsSummaryIsLoading, isFetching, error } = useGetTransactionSummaryQuery({year: selectedYear, period: selectedPeriod, userID: userID});

  //TODO this dict must come from EH API NOT HARD CODED
  let transactionTypesDict = {
    "Reward": "1",
    "Penalty": "2",
    "Deduction": "3",
    "Bonus": "4",
    "Royalty": "5",
  };

  //example response:
  // {
  //   "1": {
  //       "totalAmount": 130714.0000,
  //       "totalCount": 50
  //   },
  //   "2": {
  //       "totalAmount": 30.0000,
  //       "totalCount": 2
  //   },
  //   "3": {
  //       "totalAmount": 3110.0000,
  //       "totalCount": 1
  //   },
  //   "4": {
  //       "totalAmount": 49.0000,
  //       "totalCount": 4
  //   },
  //   "5": {
  //       "totalAmount": 3130.0000,
  //       "totalCount": 3
  //   }
  // }

  function getTotalAmountByType(type) {
    if (transactionsSummary) {
      let totalAmount = transactionsSummary[transactionTypesDict[type]]?.totalAmount;
      return totalAmount;
    }
    return 0;
  }

  function getTotalCountByType(type) {
    if (transactionsSummary) {
      let totalCount = transactionsSummary[transactionTypesDict[type]]?.totalCount;
      return totalCount;
    }
    return 0;
  }

  function getTotalAdjustment(){
    let totalPenalty = getTotalAmountByType("Penalty") || 0;
    let totalDeduction = getTotalAmountByType("Deduction") || 0;
    return totalPenalty + totalDeduction;
  }

  function getTotalCountAdjustment(){
    let totalPenalty = getTotalCountByType("Penalty") || 0;
    let totalDeduction = getTotalCountByType("Deduction")  || 0;
    return totalPenalty + totalDeduction;
  }

  function getTotalTransactionsAmount(){
    let totalRewards = getTotalAmountByType("Reward")|| 0;
    let totalBonuses = getTotalAmountByType("Bonus")|| 0;
    let totalRoyalties = getTotalAmountByType("Royalty")|| 0;
    let totalAdjustments = getTotalAdjustment()|| 0;
    return totalRewards + totalBonuses + totalRoyalties - totalAdjustments;
  }

  function getTotalTransactionsCount(){
    let totalRewards = getTotalCountByType("Reward") || 0;
    let totalBonuses = getTotalCountByType("Bonus")|| 0;
    let totalRoyalties = getTotalCountByType("Royalty")|| 0;
    let totalAdjustments = getTotalCountAdjustment()|| 0;
    return totalRewards + totalBonuses + totalRoyalties + totalAdjustments;
  }

  if(transactionsSummaryIsLoading || isFetching) return <TransactionSummarySkeleton/>
  if(error) return <div style={TableHeaderInfo} >Error: {JSON.stringify(error)}</div>

  return(
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'flex-end', margin: '0.5em 0 0 0' }} >
      
    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }} >Rewards:</p>
      <p style={{ fontWeight: '600', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }} > <MoneyFormatter value={getTotalAmountByType("Reward")} /></p>
    </div>

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Bonuses:</p>
      <p style={{ fontWeight: '600', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }} > <MoneyFormatter value={getTotalAmountByType("Bonus")} /> </p>
    </div>

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Royalties:</p>
      <p style={{ fontWeight: '600', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }} > <MoneyFormatter value={getTotalAmountByType("Royalty")}/></p>
    </div>

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 1em 0 0' }} >
      <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Adjustments:</p>
      <p style={{ fontWeight: '600', margin: '0 0.25em 0 0', whiteSpace: 'nowrap', color:'red' }} > - <MoneyFormatter value={getTotalAdjustment()}/> </p>
    </div>

    <Divider orientation="vertical" flexItem light='false' sx={{ margin: '0', borderRightWidth: 3, bgcolor: 'var(--orange)' }} />

    <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0 1em' }} >
      <p style={{ color: 'var(--orange)', fontWeight: '700', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >TOTAL:</p>
      <p style={{ color: 'var(--orange)', fontWeight: '700', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }} ><MoneyFormatter value={getTotalTransactionsAmount()}/></p>
      <p style={{ color: 'var(--orange)', fontWeight: '700', whiteSpace: 'nowrap' }} >({getTotalTransactionsCount()})</p>
    </div>

  </div>
  )
}